import { Button, Form, Modal } from 'antd';
import { useIntl } from 'react-intl';
import { useDefaultFormErrorNotification, useWindowSize } from '@/hooks';
import { ModalProps } from '@/types/ModalProps';
import { PartApplicationFormValues } from './PartApplicantionRecordsModalForm';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import PartApplicantionRecordsModalForm from './PartApplicantionRecordsModalForm';

interface Props extends ModalProps {
  onClose: () => void;
  onOk: (values: PartApplicationFormValues) => void;
  isLoading: boolean;
}

const PartApplicationRecordsCreateModal: React.FC<Props> = ({
  visible,
  handleVisible,
  onOk,
  isLoading,
}) => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const { sendFormErrorNotification } = useDefaultFormErrorNotification();
  const { isMobile } = useWindowSize();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      await onOk(values);

      form.resetFields();
    } catch (err) {
      sendFormErrorNotification(err);
    }
  };

  const handleCancel = () => {
    form.resetFields();

    handleVisible();
  };

  return (
    <Modal
      title={'Aplicação da peça - Cadastros'}
      open={visible}
      onCancel={handleCancel}
      confirmLoading={isLoading}
      width={620}
      destroyOnClose
      footer={[
        <SpaceForButton flexDirection={isMobile ? 'column' : 'row-reverse'}>
          <Button block type="primary" onClick={handleOk} loading={isLoading}>
            {intl.formatMessage({ id: 'commons.modal.button.save' })}
          </Button>
          <Button block type="primary" ghost onClick={handleCancel}>
            {intl.formatMessage({ id: 'commons.modal.button.cancel' })}
          </Button>
        </SpaceForButton>,
      ]}
    >
      <PartApplicantionRecordsModalForm form={form} />
    </Modal>
  );
};

export default PartApplicationRecordsCreateModal;
